import {css} from '@emotion/react'
import {Button} from 'antd'
import {useAiContext} from './AiContext.mjs'

const cssButton = css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 32,
    color: '#4c4c4c !important',
    backgroundColor: 'transparent !important',
    border: 'none',

    '&:hover': {
        backgroundColor: '#e0e4ed !important',
    },

    '&[disabled]': {
        color: 'rgb(214, 222, 232) !important',
        backgroundColor: 'transparent !important',
    },

    '&.ant-btn-primary': {
        color: '#fff !important',
        backgroundColor: '#4d6bfe !important',

        '&:hover': {
            backgroundColor: '#2563eb !important',
        },

        '&[disabled]': {
            color: '#fafafa !important',
            backgroundColor: 'rgb(214, 222, 232) !important',
        },
    }
})

const cssButtonCompact = css({
    height: 24,
})

export const DraftButton = ({disabled, ...props}) => {
    const ai = useAiContext()

    return (
        <Button
            css={[cssButton, ai.compactView && cssButtonCompact]}
            disabled={disabled || ai.getIsDisabled()}
            size="small"
            type="link"
            {...props}
        />
    )
}

const cssIconButton = css({
    width: 32,
    minWidth: 0,
    fontSize: 20,

    '.anticon': {
        lineHeight: 0,
    }
})

const cssIconButtonCompact = css({
    width: 24,
    fontSize: 16,
})

export const DraftIconButton = ({disabled, ...props}) => {
    const ai = useAiContext()

    return (
        <Button
            css={[
                cssButton,
                cssIconButton,
                ai.compactView && cssButtonCompact,
                ai.compactView && cssIconButtonCompact,
            ]}

            disabled={disabled || ai.getIsDisabled()}
            shape="circle"
            {...props}
        />
    )
}
